import * as React from 'react';
import { ResourceEntityAccessLevels } from "../../../store/permissions";
import { Checkbox, ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react';
import './ResourceEntityAccessLevel.css';
import InfoableComponent from '../../common/InfoableComponent';
interface Props {
    readOnly?: boolean;
    label: string;
    description: string | JSX.Element;
    perms?: ResourceEntityAccessLevels;
    indeterminate?: () => boolean | undefined;
    assignedDescription: string;
    onChange: (changes: ResourceEntityAccessLevels) => void;
}

export const ResourceEntityAccessLevel = (props: Props) => {
    const { readOnly, perms, label, assignedDescription } = props;

    const onRenderAccessLevel = (opt?: IChoiceGroupOption, defaultRender?: (opt?: IChoiceGroupOption) => JSX.Element | null): JSX.Element | null =>
        <InfoableComponent description={assignedDescription}>{defaultRender?.(opt)}</InfoableComponent>;

    const options: IChoiceGroupOption[] = [
        {
            key: ResourceEntityAccessLevels.All.toString(),
            text: "All Resources",
            value: ResourceEntityAccessLevels.All
        },
        {
            key: ResourceEntityAccessLevels.AssignedAll.toString(),
            text: "Designated Resources",
            value: ResourceEntityAccessLevels.AssignedAll,
            onRenderField: onRenderAccessLevel
        },
    ];

    const onCheckChange = (isChecked: boolean) => {
        const accessLevel = isChecked ? ResourceEntityAccessLevels.All : ResourceEntityAccessLevels.None;
        props.onChange(accessLevel);
    }

    const selected = perms == ResourceEntityAccessLevels.None ? undefined : perms?.toString();
    const indeterminate = props.indeterminate?.();

    return <div>
        <InfoableComponent description={props.description}>
            <Checkbox
                disabled={readOnly}
                label={label}
                indeterminate={indeterminate}
                checked={perms !== ResourceEntityAccessLevels.None}
                onChange={(ev, c: boolean) => onCheckChange(c)} />
        </InfoableComponent>
        {perms != ResourceEntityAccessLevels.None && <ChoiceGroup
            className={`resource-management-access-level ${indeterminate ? "is-indeterminated" : ""}`}
            selectedKey={indeterminate ? undefined : selected}
            options={options}
            disabled={readOnly}
            onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => props.onChange(option?.value as ResourceEntityAccessLevels)}
        />}
    </div>
}